/* eslint-disable no-unsafe-optional-chaining */
import { FormControl, Input, ListItemText, MenuItem, Checkbox, ListSubheader } from '@material-ui/core';
import React, { useState } from 'react';
import Select from '@mui/material/Select';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { makeStyles } from '@material-ui/styles';
import Theme from '../ui/Theme';

export const useStyles = makeStyles(() => ({
  textfield: (props) => ({
    backgroundColor: Theme.palette.secondary.main,
    height: props.height,
    width: props.width,
    marginBottom: props.marginBottom,
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '21px',
    marginTop: '12px',
  }),
  listSubheader: {
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    color: 'black',
    fontFamily: 'Montserrat',
  },
}));

const getDealershipStyles = (dealershipChildren) => {
  if (!dealershipChildren) return {};
  return dealershipChildren?.reduce((acc, d) => {
    acc[d.id] = '';
    return acc;
  }, {});
};

const EnableReportingMultiDropDown = (props) => {
  const [dealershipStyles, setDealershipStyles] = useState(() => getDealershipStyles(props.dealershipChildren));

  const styleProps = {
    width: props.width,
    height: props.height,
    marginBottom: props.marginBottom,
  };
  const classes = useStyles(styleProps);
  const ITEM_HEIGHT = 80;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const renderSelectGroup = (deal) => {
    const items = props.deptList?.map((dept) => (
      <MenuItem
        style={{ marginLeft: '10px', display: dealershipStyles[deal.id] }}
        key={`${deal.id}-${dept.id}`}
        value={`${deal.id}-${dept.id}`}
      >
        <Checkbox
          color="primary"
          checked={props.enableReportingChildren?.some((el) => el === `${deal.id}-${dept.id}`)}
        />
        <ListItemText primary={dept.title ? dept.title : dept.name} />
      </MenuItem>
    ));
    return [
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          <Checkbox
            color="primary"
            onChange={(e) => {
              if (e.target.checked) {
                const check = new Set([
                  ...props.enableReportingChildren,
                  ...props.deptList?.map((d) => `${deal.id}-${d.id}`),
                ]);
                props.handleChangeEnableReporting([...check]);
              } else {
                const tempArr = props.enableReportingChildren?.filter((a) => parseInt(a.split('-')[0], 10) !== deal.id);
                props.handleChangeEnableReporting(tempArr);
              }
            }}
            checked={props.deptList?.every((d) => props.enableReportingChildren?.includes(`${deal.id}-${d.id}`))}
          />
          <ListSubheader disableSticky className={classes.listSubheader}>
            {deal.name}
          </ListSubheader>
        </div>
        {dealershipStyles[deal.id] === 'none' ? (
          <ArrowDropDownIcon
            onClick={() => setDealershipStyles({ ...dealershipStyles, [deal.id]: '' })}
            style={{ marginRight: '10px', fontSize: '40px', cursor: 'pointer' }}
          />
        ) : (
          <ArrowDropUpIcon
            onClick={() => setDealershipStyles({ ...dealershipStyles, [deal.id]: 'none' })}
            style={{ marginRight: '10px', fontSize: '40px', cursor: 'pointer' }}
          />
        )}
      </div>,
      items,
    ];
  };

  return (
    <FormControl>
      <Select
        name={props.name}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={props.enableReportingChildren || []}
        onChange={(e) => props.handleChangeEnableReporting(e.target.value)}
        input={<Input disableUnderline className={classes.textfield} />}
        renderValue={(selected) => `${selected?.length || 0} selected`}
        MenuProps={MenuProps}
        multiple
      >
        {props.dealershipChildren?.map((deal) => renderSelectGroup(deal))}
      </Select>
    </FormControl>
  );
};

export default EnableReportingMultiDropDown;
